/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_ExplanationInputs */

const en_gift_explanation = /** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you buy as a gift, you don't need the recipient's address. After purchase, you'll get a 'Master Link' in your Vault. Just send that link to your friend! They'll be able to claim the gift and provide their own delivery details.`)
};

const es_gift_explanation = /** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando compras como regalo, no necesitas la dirección del destinatario. Después de la compra, obtendrás un 'Enlace Maestro'. ¡Envíale ese enlace a tu amigo! Ellos podrán reclamar el regalo y proporcionar sus detalles de entrega.`)
};

const fr_gift_explanation = /** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lorsque vous achetez pour offrir, vous n'avez pas besoin de l'adresse du destinataire. Après l'achat, vous obtiendrez un 'Lien Maître' dans votre Coffre-fort. Envoyez simplement ce lien à votre ami ! Il pourra réclamer le cadeau et fournir ses propres détails de livraison.`)
};

const de_gift_explanation = /** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du als Geschenk kaufst, benötigst du die Adresse des Empfängers nicht. Nach dem Kauf erhältst du einen 'Master-Link' in deinem Vault. Sende diesen Link einfach an deinen Freund! Er kann das Geschenk einlösen und seine eigenen Lieferdetails angeben.`)
};

const id_gift_explanation = /** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat Anda membeli sebagai hadiah, Anda tidak memerlukan alamat penerima. Setelah pembelian, Anda akan mendapatkan 'Tautan Utama' di Vault Anda. Cukup kirim tautan itu ke teman Anda! Mereka akan dapat mengklaim hadiah dan memberikan detail pengiriman mereka sendiri.`)
};

/** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */
const ja_gift_explanation = en_gift_explanation;

/** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */
const zh_gift_explanation = en_gift_explanation;

/** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */
const ar_gift_explanation = en_gift_explanation;

/** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */
const it_gift_explanation = en_gift_explanation;

/** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */
const ru_gift_explanation = en_gift_explanation;

/** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */
const pt_gift_explanation = en_gift_explanation;

/** @type {(inputs: Gift_ExplanationInputs) => LocalizedString} */
const ko_gift_explanation = en_gift_explanation;

/**
* | output |
* | --- |
* | "When you buy as a gift, you don't need the recipient's address. After purchase, you'll get a 'Master Link' in your Vault. Just send that link to your friend!..." |
*
* @param {Gift_ExplanationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_explanation = /** @type {((inputs?: Gift_ExplanationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_ExplanationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_explanation(inputs)
	if (locale === "es") return es_gift_explanation(inputs)
	if (locale === "fr") return fr_gift_explanation(inputs)
	if (locale === "de") return de_gift_explanation(inputs)
	if (locale === "ja") return ja_gift_explanation(inputs)
	if (locale === "zh") return zh_gift_explanation(inputs)
	if (locale === "ar") return ar_gift_explanation(inputs)
	if (locale === "id") return id_gift_explanation(inputs)
	if (locale === "it") return it_gift_explanation(inputs)
	if (locale === "ru") return ru_gift_explanation(inputs)
	if (locale === "pt") return pt_gift_explanation(inputs)
	return ko_gift_explanation(inputs)
});